import { palette } from '@/styles/shared';
interface CalendarIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: string;
  fill?: string;
}

const CalendarIcon = ({ 
  width = 20, 
  height = 20, 
  stroke = palette.mutedText,
  strokeWidth = "1.25",
  fill = palette.mutedText
}: CalendarIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M6.25 1.25V3.75M13.75 1.25V3.75M2.5 6.25H17.5M3.75 3.75H16.25C17.0784 3.75 17.75 4.42157 17.75 5.25V16.25C17.75 17.0784 17.0784 17.75 16.25 17.75H3.75C2.92157 17.75 2.25 17.0784 2.25 16.25V5.25C2.25 4.42157 2.92157 3.75 3.75 3.75Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.375 7.5H11.25V12.125H4.375V7.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default CalendarIcon;
